import React from 'react'

export default function Home() {
  return (
    <>
      <section className='main-section'>
        <div className='webConst'> The website is under construction...</div>
      </section>
    </>
  )
}
